import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const GradebookPage = lazy(() =>
  import('./pages/GradebookPage').then(m => ({ default: m.GradebookPage }))
);
const AttendancePage = lazy(() =>
  import('./pages/AttendancePage').then(m => ({ default: m.AttendancePage }))
);
const PupilProgressPage = lazy(() =>
  import('./pages/PupilProgressPage').then(m => ({ default: m.PupilProgressPage }))
);
const MyProgressPage = lazy(() =>
  import('./pages/MyProgressPage').then(m => ({ default: m.MyProgressPage }))
);

/**
 * Progress routes, gated exactly like the API (ADR-015): the gradebook and the
 * attendance register are staff-only and class-scoped, while a pupil progress
 * page is readable by staff, the pupil themself and their parents — so its
 * route admits all four roles and the server (`can_view_pupil_progress`) stays
 * the authority on WHICH pupil.
 */
export const progressRoutes = (
  <>
    <Route element={<RequireRole roles={['admin', 'teacher']} />}>
      <Route path="/gradebook" element={<GradebookPage />} />
      <Route path="/attendance" element={<AttendancePage />} />
    </Route>
    <Route element={<RequireRole roles={['admin', 'teacher', 'pupil', 'parent']} />}>
      <Route path="/progress/pupils/:memberPublicId" element={<PupilProgressPage />} />
    </Route>
    <Route element={<RequireRole roles={['pupil']} />}>
      <Route path="/progress/me" element={<MyProgressPage />} />
    </Route>
  </>
);
